import fetch from 'auth/FetchInterceptor'

const AuthService = {}

// splitshire-v2: POST /auth/login { email, password } -> { data: { user, token }, success }
AuthService.login = function (data) {
	return fetch({
		url: '/auth/login',
		method: 'post',
		data: data
	}).then((res) => {
		// Map v2 response to expected shape (access_token, user)
		if (res?.data?.token != null) {
			return { ...res, access_token: res.data.token, token: res.data.token, user: res.data.user };
		}
		return res;
	});
}

AuthService.register = function (data) {
	return fetch({
		url: '/auth/register',
		method: 'post',
		data: data
	})
}

AuthService.logout = function () {
	return fetch({
		url: '/auth/logout',
		method: 'post'
	})
}

AuthService.loginInOAuth = function () {
	return fetch({
		url: '/auth/loginInOAuth',
		method: 'post'
	})
}

export default AuthService;